export default __webpack_public_path__ + "static/media/category_03.550068ea.png";